import './style.css'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import * as dat from 'lil-gui'
import { HemisphereLight } from 'three'
import { RectAreaLightHelper } from 'three/examples/jsm/helpers/RectAreaLightHelper.js'

/**
 * Base
 */
// Debug
const gui = new dat.GUI()

const parameters = {
    color: 0xffffff
}


// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()

/**
 * Lights
 * minimal cost lights are ambientlight and hemisphere light
 * moderate cost directionallight and pointlight
 * high cost spotlight and rect area light
 */
const ambientLight = new THREE.AmbientLight(0xffffff, 0.2)
scene.add(ambientLight)

const directionalLight = new THREE.DirectionalLight(0x00fffc,0.3)
directionalLight.position.set(1,0.25,0)
scene.add(directionalLight)


const hemisphereLight = new THREE.HemisphereLight(0xff0000,0x0000ff, 0.1)
scene.add(hemisphereLight)

const pointLight = new THREE.PointLight(0xff9000,1,10,2)
pointLight.position.set( 1, -0.5, 1 )
scene.add(pointLight)

const rectAreaLight = new THREE.RectAreaLight(0xff00ff,1.5,1.5,1.5)
rectAreaLight.position.set( -1.5, 0 , 1.5)
rectAreaLight.lookAt( 1, 0, 1.3 )
scene.add(rectAreaLight)

const spotLight = new THREE.SpotLight(0x78ff00,0.5,10, Math.PI* 0.1, 0.25, 1)
spotLight.position.set(3,5,-2)
scene.add(spotLight)
spotLight.target.position.x =2
scene.add(spotLight.target)



/**
 * Helpers
 */
/* const hemisphereLightHelper = new THREE.HemisphereLightHelper(hemisphereLight,0.1)
scene.add(hemisphereLightHelper)

const directionalLightHelper = new THREE.DirectionalLightHelper(directionalLight,0.1)
scene.add(directionalLightHelper)

const pointLightHelper = new THREE.PointLightHelper(pointLight,0.1)
scene.add(pointLightHelper)

const helper = new RectAreaLightHelper( rectAreaLight );
rectAreaLight.add(helper)

const spotLightHelper = new THREE.SpotLightHelper(spotLight)
scene.add(spotLightHelper)
//update on the next frame
window.requestAnimationFrame(()=>
{
    spotLightHelper.update()
}) 
 */
/**
 * GUI
 */

const ambientLightFolder = gui.addFolder('ambientLight')
ambientLightFolder.add(ambientLight,'intensity').min(0).max(1).step(0.01)

ambientLightFolder.
addColor(parameters, 'color').name('ambientLight Color')
.onChange(() =>
{

    ambientLight.color.set(parameters.color)
})
ambientLightFolder.open()

const directionalLightFolder = gui.addFolder('directionalLight')
directionalLightFolder.add(directionalLight,'intensity').min(0).max(1).step(0.01)
parameters.color = 0x00fffc
directionalLightFolder.
addColor(parameters, 'color').name('directionLight Color')
.onChange(() =>
{
    directionalLight.color.set(parameters.color)
})
directionalLightFolder.open()

const hemisphereLightFolder = gui.addFolder('hemisphereLight')
hemisphereLightFolder.add(hemisphereLight,'intensity').min(0).max(1).step(0.01)
 parameters.color = 0xff0000
hemisphereLightFolder.
addColor(parameters, 'color').name('skyColor')
.onChange(() =>
{
    hemisphereLight.color.set(parameters.color)
})
parameters.color = 0x0000ff
hemisphereLightFolder.
addColor(parameters, 'color').name('groundColor')
.onChange(() =>
{
    hemisphereLight.groundColor.set(parameters.color)
})
hemisphereLightFolder.open()

const pointLightFolder = gui.addFolder('pointLight')
pointLightFolder.add(pointLight,'intensity').min(0).max(6).step(0.01)
pointLightFolder.add(pointLight,'distance').min(1).max(10).step(0.1)
pointLightFolder.add(pointLight,'decay').min(1).max(10).step(0.1)
parameters.color = 0xff9000
pointLightFolder.
addColor(parameters, 'color').name('pointLight Color')
.onChange(() =>
{
    pointLight.color.set(parameters.color)
})
pointLightFolder.open()

const rectAreaLightFolder = gui.addFolder('rectAreaLight')
rectAreaLightFolder.add(rectAreaLight,'intensity').min(0.3).max(2).step(0.01)
rectAreaLightFolder.add(rectAreaLight.position,'x').min(-2).max(2).step(0.01).name('position X')
rectAreaLightFolder.add(rectAreaLight.position,'y').min(-2).max(2).step(0.01).name('position Y')
rectAreaLightFolder.add(rectAreaLight.position,'z').min(-2).max(2).step(0.01).name('position Z')
rectAreaLightFolder.add(rectAreaLight, 'width').min(0.5).max(3).step(0.01)
rectAreaLightFolder.add(rectAreaLight, 'height').min(0.5).max(3).step(0.01)
parameters.color = 0xff00ff
rectAreaLightFolder.
addColor(parameters, 'color').name('rectAreaLight Color')
.onChange(() =>
{
    rectAreaLight.color.set(parameters.color)
})
rectAreaLightFolder.open()


const spotLightFolder = gui.addFolder('spotLight')
spotLightFolder.add(spotLight,'intensity').min(0).max(1).step(0.01)
spotLightFolder.add( spotLight, 'distance' ).min(1).max(15).step(0.5).name('Light distance');
spotLightFolder.add(spotLight, 'decay').min(0.1).max(2.5).step(0.01)
spotLightFolder.add(spotLight, 'penumbra').min(0).max(1).step(0.01)
parameters.color = 0x78ff00
spotLightFolder.
addColor(parameters, 'color').name('spotLight Color')
.onChange(() =>
{

    spotLight.color.set(parameters.color)
})
spotLightFolder.open()



/**
 * Objects
 */
// Material
const material = new THREE.MeshStandardMaterial()
material.roughness = 0.4

// Objects
const sphere = new THREE.Mesh(
    new THREE.SphereGeometry(0.5, 32, 32),
    material
)
sphere.position.x = - 1.5

const cube = new THREE.Mesh(
    new THREE.BoxGeometry(0.75, 0.75, 0.75),
    material
)

const torus = new THREE.Mesh(
    new THREE.TorusGeometry(0.3, 0.2, 32, 64),
    material
)
torus.position.x = 1.5

const plane = new THREE.Mesh(
    new THREE.PlaneGeometry(5, 5),
    material
)
plane.rotation.x = - Math.PI * 0.5
plane.position.y = - 0.65

scene.add(sphere, cube, torus, plane)



/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
camera.position.x = 1
camera.position.y = 1
camera.position.z = 2
scene.add(camera)

// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

/**
 * Animate
 */
const clock = new THREE.Clock()

const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()

    // Update objects
    sphere.rotation.y = 0.1 * elapsedTime
    cube.rotation.y = 0.1 * elapsedTime
    torus.rotation.y = 0.1 * elapsedTime

    sphere.rotation.x = 0.15 * elapsedTime
    cube.rotation.x = 0.15 * elapsedTime
    torus.rotation.x = 0.15 * elapsedTime

    // Update controls
    controls.update()

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()